import React from 'react';

const Developers = () => {
  return (
    <div>Sandbox</div>
  );
};

export default Developers;
